import { getWindow } from '../getWindow';

export type Bounds = {
  width: number;
  height: number;
};

export const getWindowBounds = (win = getWindow()): Bounds => {
  const viewport = win.visualViewport as VisualViewport | undefined;

  return {
    width:
      viewport?.width !== undefined
        ? Math.min(win.innerWidth, viewport.width)
        : win.innerWidth,

    height:
      viewport?.height !== undefined
        ? Math.min(win.innerHeight, viewport.height)
        : win.innerHeight,
  };
};
